import { TokenServiceClient } from '@johnlewispartnership/wtr-website-authentication/dist/service';
import type { TokenClientError } from '@johnlewispartnership/wtr-website-authentication/dist/service/TokenServiceClient';
import config from 'config';
import { logger } from 'logger';
import getApiBaseUrl from 'utils/getApiBaseUrl';

const formatError = (e: TokenClientError) => ({
  // TODO: this need more work to include things like customerID, ip, etc...
  payload: {
    service: 'token',
    logType: 'authentication',
    url: `${getApiBaseUrl(config.services.tokenClient.path)}/...`,
    message: e.message,
    ...(e.originalError?.message && {
      errorDetails: {
        message: e.originalError?.message,
      },
    }),
  },
});

export default new TokenServiceClient(getApiBaseUrl(config.services.tokenClient.path), {
  // TODO: WPIP-67026 refactor this. It should be up to the client application to decide what level to
  // log the error at. We should make the auth package return the `status` and decide in the Common MFE how to
  // log it. We shouldn't pass a "logger" into the auth package at all, but have it throw exceptions which we catch.
  info: e => {
    logger.info(formatError(e));
  },
  error: e => {
    logger.error(formatError(e));
  },
});
